import styled from 'styled-components';
import { InputAdornment, Tab, Tabs, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import type { DeviceStatus, Device } from '@/@types/device';
import { atom, useAtom, useSetAtom } from 'jotai';
import { devicesAtom } from '@/interfaces/devices';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SearchBoxWrap = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-content: center;
`;

type FilterStatus = 'all' | DeviceStatus | 'etc' | 'keyword';

export const filterdListAtom = atom<Device[]>();

const tabIndexAtom = atom<FilterStatus>('all');

export default function Filter() {
  const { t } = useTranslation();
  const setFilterdList = useSetAtom(filterdListAtom);
  const [{ data: deviceList }] = useAtom(devicesAtom);
  const [tabIndex, setTabIndex] = useAtom(tabIndexAtom);

  const [keyword, setKeyword] = useState<string>();

  useEffect(() => {
    if (deviceList) {
      listFilter(tabIndex, keyword);
    }
  }, [deviceList]);

  const listFilter = (selectedVal: FilterStatus, keyword: string) => {
    let retList: Device[] = deviceList;
    switch (selectedVal) {
      case 'online':
        retList = deviceList.filter((target: Device) => target.status === 'online');
        break;
      case 'offline':
        retList = deviceList.filter((target: Device) => target.status === 'offline');
        break;
      case 'etc':
        retList = deviceList.filter((target: Device) => target.status !== 'online' && target.status !== 'offline');
        break;
      case 'all':
      default:
        break;
    }
    if (keyword && keyword !== '') {
      retList = retList.filter((target: Device) => target.name.indexOf(keyword) > -1);
    }
    setFilterdList(retList);
  };

  const handleTabChange = (selectedVal: FilterStatus) => {
    if (deviceList) {
      setTabIndex(selectedVal);
      listFilter(selectedVal, keyword);
    }
  };
  const handleSearchChange = (val: string) => {
    setKeyword(val);
  };
  const handleSearchKeydown = (key: string) => {
    if (key === 'Enter') {
      listFilter(tabIndex, keyword);
    }
  };

  return (
    <>
      <SearchBoxWrap>
        <TextField
          id="input-with-icon-textfield"
          label={t('Common.label.search')}
          size="small"
          sx={{
            bgcolor: '#ffffff',
            flexGrow: 1,
          }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon onClick={() => handleSearchKeydown('Enter')} />
                </InputAdornment>
              ),
            },
          }}
          onChange={(e) => handleSearchChange(e.target.value)}
          onKeyDown={(e) => handleSearchKeydown(e.key)}
        />
      </SearchBoxWrap>
      <Tabs onChange={(e, val) => handleTabChange(val)} aria-label="lab API tabs example" value={tabIndex}>
        <Tab
          label={`${t('Common.label.all')}(${deviceList && deviceList.length})`}
          sx={{ textTransform: 'none' }}
          value={'all'}
        />
        <Tab
          label={`${t('Devices.label.online')}(${deviceList && deviceList.filter((device) => device.status === 'online').length})`}
          sx={{ textTransform: 'none' }}
          value={'online'}
        />
        <Tab
          label={`${t('Devices.label.offline')}(${deviceList && deviceList.filter((device) => device.status === 'offline').length})`}
          sx={{ textTransform: 'none' }}
          value={'offline'}
        />
        <Tab
          label={`${t('Devices.label.etc')}(${deviceList && deviceList.filter((device) => device.status !== 'online' && device.status !== 'offline').length})`}
          sx={{ textTransform: 'none' }}
          value={'etc'}
        />
      </Tabs>
    </>
  );
}
